// extracted by mini-css-extract-plugin
module.exports =  {"root":"KGxAE3txOx_wP9YRkBQY"};